const savedAddresses = [
  {
    id: 1,
    name: "Rajesh Kumar",
    building: "G-24 Gokuldham Shopping Center",
    streetLine: "Film city road, Goregaon (E)",
    city: "Mumbai",
    state: "Maharashtra",
  },
  {
    id: 2,
    name: "Priya Sharma",
    building: "45, Shreeje Apts, Versova Road",
    streetLine: "Near Rajkamal Hotel, Andheri (W)",
    city: "Mumbai",
    state: "Maharashtra",
  },
  {
    id: 3,
    name: "Sunil Verma",
    building: "12th Floor, Free Press House",
    streetLine: "Yogakshema (Nariman Point)",
    city: "Kolkata",
    state: "West Bengal",
  },
];

export default savedAddresses;
